import { passCodes } from '../passCodes';

export const step28door = {
    id: 28,
    title: 'Vrata',
    taskText: `
        <p> 
            Odpovězte správně a posunte se dál. Odpovědi najdete někde v okolí.
        </p>
    `,
    cipher: {
        text: `
            <p>
                <b>3. otázka ze 4:</b>
            </p>
            <p>
                Kolik cípů má hvězda nade dveřmi?
            </p>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[11],
    additionalInfo: 'Odpovědí je číslo',
    points: false,
    hints: [
        {
            text: 'Správná odpověď je 6',
        },
    ],
};
